import { Button, Flex, message, Table, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import AxiosService from '../services/APIService';
import dayjs from 'dayjs';
import CreateNoteModel from './CreateNoteModel';

const Notes = () => {
    const apiService = new AxiosService()
    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [noteList, setNoteList] = useState([])

    useEffect(() => {
        fetchNote();
    }, [isModalOpen]);

    const columns = [
        {
            title: "#",
            dataIndex: "count",
            key: "count",
            width: "50px",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            width: 200
        },
        {
            title: "Note",
            dataIndex: "note",
            key: "note",
        },
        {
            title: "Reply",
            dataIndex: "reply",
            key: "reply",
        },
    ];

    const fetchNote = () => {
        setLoading(true);
        apiService.get("/notes/list")
            .then((res) => {
                setNoteList(res.notes.map((note, index) => ({
                    key: note._id,
                    count: index + 1,
                    note: note.note,
                    date: dayjs(note.createDate).format("DD-MM-YYYY"),
                    reply: note.reply?.text || "-",
                })));
            })
            .catch((e) => {
                message.error(e.message || "Something went wrong");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div>
            <Typography.Title level={3} className="page-title">
                Notes
            </Typography.Title>
            <Flex justify='end' style={{ marginBottom: '15px' }}>
                <Button type="primary" onClick={() => setIsModalOpen(true)}>
                    Create
                </Button>
            </Flex>
            <Table loading={loading} columns={columns} dataSource={noteList} />
            <CreateNoteModel isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} setLoading={setLoading}/>
        </div>
    )
}

export default Notes